import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomUserActions } from '../store/actions';
import { CustomUserSelectors } from '../store/selectors';
import { StateWithCustomUser } from '../store/user-state';

@Injectable({
  providedIn: 'root',
})
export class SubmitAuthCodeFacade {
  constructor(private store: Store<StateWithCustomUser>) {}

  submitAuthCode(code: string): void {
    this.store.dispatch(new CustomUserActions.SubmitAuthCode(code));
  }

  submitAuthCodeSuccess(): void {
    this.store.dispatch(new CustomUserActions.SubmitAuthCodeSuccess());
  }

  submitAuthCodeError(error: unknown): void {
    this.store.dispatch(new CustomUserActions.SubmitAuthCodeFailure(error));
  }

  resetSubmitAuthCodeState(): void {
    this.store.dispatch(new CustomUserActions.SubmitAuthCodeResetState());
  }

  getSubmitAuthCode(): Observable<StateUtils.LoaderState<string>> {
    return this.store.pipe(select(CustomUserSelectors.getSubmitAuthCodeState));
  }

  getSubmitAuthCodeValue(): Observable<string> {
    return this.store.pipe(select(CustomUserSelectors.getSubmitAuthCodeValue));
  }

  getSubmitAuthCodeLoading(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getSubmitAuthCodeLoading));
  }

  getSubmitAuthCodeSuccess(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getSubmitAuthCodeSuccess));
  }

  getSubmitAuthCodeError(): Observable<boolean> {
    return this.store.pipe(select(CustomUserSelectors.getSubmitAuthCodeError));
  }
}
